import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#top">
            <span><img src="../img/logo.webp" alt="K&L Delicatessen" width="35" height="35"/> K&L Delicatessen</span>
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="https://www.toasttab.com/k-l-delicatessen-7601-37th-ave/giftcards?utm_source=undefined&utm_content=online--k-l-delicatessen-7601-37th-ave&utm_medium=toast_sites&utm_campaign=giftcards" 
                className="page-scroll"
                target="_blank"
                rel="noopener noreferrer" 
              >
                e-Gift Cards
              </a>
            </li>
            <li >
              <a href="https://www.toasttab.com/k-l-delicatessen-7601-37th-ave"
                target="_blank"
                rel="noopener noreferrer" >
                <b>Order Online</b>
              </a>
              {/* <span class="glf-button" data-glf-cuid="8c23f724-a2a8-44d5-8807-f7dbbd5ff005" data-glf-ruid="077ee8b1-d71c-4f3b-9d3d-e669532b3035" >Order Now</span> */}

            </li>
            {/* <li>
              <a href="#about" className="page-scroll">
                About
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                Services
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll">
                Gallery
              </a>
            </li>
            <li>
              <a href="#testimonials" className="page-scroll">
                Testimonials
              </a>
            </li>
            <li>
              <a href="#team" className="page-scroll">
                Team
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li> */}
          </ul>
        </div>
      </div>
    </nav>
  );
};
